export const BeeMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path d="M24 12l4-7 4 5 4-5 4 7-2 4H26z" fill="#f3ad38" />
    <path d="M28 13c-2-5-6-8-9-9M36 13c2-5 6-8 9-9" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" />
    <ellipse cx="14" cy="22" rx="13" ry="7.5" fill="#6b3ba7" opacity="0.9" transform="rotate(-28 14 22)" />
    <ellipse cx="50" cy="22" rx="13" ry="7.5" fill="#6b3ba7" opacity="0.9" transform="rotate(28 50 22)" />
    <ellipse cx="32" cy="35" rx="10.5" ry="15" fill="#f3ad38" />
    <path d="M22.5 30h19M22 36h20M23.5 42h17" stroke="#1e2420" strokeWidth="3.4" strokeLinecap="round" />
    <circle cx="28.5" cy="22" r="1.6" fill="#1e2420" />
    <circle cx="35.5" cy="22" r="1.6" fill="#1e2420" />
    <path d="M16 55c5-6 11-8 16-8s11 2 16 8c-5 3-11 4-16 4s-11-1-16-4z" fill="#2e5b38" />
  </svg>
);
